import React, { useEffect, useState } from 'react'
import classnames from 'classnames'

const SpinnerOverlay = ({ children, visible, allWhiteBackground }) => {
  const [hide, setHide] = useState(!visible)
  const [whiteBackground, setWhiteBackground] = useState(false)

  useEffect(() => {
    if (allWhiteBackground) {
      setWhiteBackground(true)
    }
    setTimeout(() => {
      setHide(!visible)
    }, 300)
  }, [visible])

  return (
    <>
      <div
        className={classnames('spinner-overlay w-100 h-100 position-absolute', {
          visible,
          hidden: hide,
          whiteBackground,
        })}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
      {children}
    </>
  )
}

export default SpinnerOverlay
